module.exports = __webpack_public_path__ + "img/hexagon-half.868f0294.svg";